import styled from 'styled-components';

const options = {
  color: {
    lightGray: 'filter: invert(0.55);',
    gray: 'filter: invert(0.67);',
    black: 'filter: invert(1);',
    white: 'filter: invert(0);',
  },
  size: {
    xxs: { width: 8, height: 8 },
    xs: { width: 12, height: 12 },
    sm: { width: 14, height: 14 },
    md: { width: 16, height: 16 },
    lg: { width: 20, height: 20 },
    xl: { width: 32, height: 32 },
    xxl: { width: 50, height: 50 },
  },
};

export const ImageStyled = styled.img`
  ${(props) => props.size && options.size[props.size]};
  ${(props) => props['data-color'] && options.color[props['data-color']]};
`;
